import {
  IsArray,
  IsInt,
  IsNumber,
  IsOptional,
  IsString,
} from 'class-validator';

export class BoipaSessionTokenResponseDto {
  @IsString()
  result: string;

  @IsNumber()
  merchantId: number;

  @IsString()
  token: string;

  @IsString()
  resultId: string;

  @IsInt()
  processingTime: number;

  @IsArray()
  @IsOptional()
  additionalDetails?: any[];

  @IsArray()
  @IsOptional()
  errors?: string[];
}
